export default "__VITE_ASSET__BhmE65RP__"